import { useEffect, useState } from 'react';

import { billingApi } from '../../api/billing.js';
import { exportApi } from '../../api/export.js';
import { ExportCsvButton, LoadingState, Tabs } from '../../components/ui';
import { useUrlParam } from '../../url';
import { AlertsTable, AuditTable } from './AuditTable.jsx';

export default function AuditLog() {
  const [logs,   setLogs]   = useState(null);
  const [alerts, setAlerts] = useState(null);
  // Sub-tab in the URL: /audit?sub=alerts is a link straight to the failures.
  const [tab, setTab] = useUrlParam('sub', 'log', { replace: false });

  useEffect(() => {
    billingApi.audit().then(setLogs).catch(() => setLogs([]));
    billingApi.alerts().then(setAlerts).catch(() => setAlerts([]));
  }, []);

  const tabs = [
    { id: 'log',    label: `Audit Log ${logs ? `(${logs.length})` : ''}` },
    { id: 'alerts', label: `Alerts ${alerts ? `(${alerts.length})` : ''}` },
  ];

  return (
    <div>
      <div className="section-title">Audit Log</div>
      <Tabs tabs={tabs} activeId={tab} onChange={setTab} />

      {tab === 'log' && (
        <>
          {logs === null ? (
            <LoadingState>Loading audit log...</LoadingState>
          ) : logs.length === 0 ? (
            <div className="alert alert-info">No audit entries yet.</div>
          ) : (
            <>
              {/* The page shows the latest 100; the export is the full log.
                  That is the point of exporting an audit trail at all. */}
              <div style={{
                display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12,
              }}>
                <ExportCsvButton
                  onExport={() => exportApi.download('audit_log')}
                  title="Download the full audit log as CSV — not just the entries shown here"
                />
                <span style={{ fontSize: 12, color: '#666' }}>
                  Showing {logs.length} entries — the export covers the full log.
                </span>
              </div>
              <AuditTable rows={logs} />
            </>
          )}
        </>
      )}

      {tab === 'alerts' && (
        <>
          {alerts === null ? (
            <LoadingState>Loading alerts...</LoadingState>
          ) : alerts.length === 0 ? (
            <div className="alert alert-success">No alerts or failures.</div>
          ) : (
            <>
              <div style={{
                display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12,
              }}>
                <ExportCsvButton
                  onExport={() => exportApi.download('alerts')}
                  title="Download every alert as CSV — not just the entries shown here"
                />
                <span style={{ fontSize: 12, color: '#666' }}>
                  Showing {alerts.length} entries — the export covers them all.
                </span>
              </div>
              <AlertsTable rows={alerts} />
            </>
          )}
        </>
      )}
    </div>
  );
}
